import { AsteriskNotification } from "Components/AsteriskNotification";
import { BulmaNavButtons } from "Components/BulmaNavButtons";
import { Horizontal } from "Components/Horizontal";
import { SmallIcon } from "Components/SmallIcon";
import { ErrorMessage } from "Inputs/Tools";
import React from "react";
import { AddStandardAIInput } from "Views/Shared/AddStandardAIInput";
import { Heading } from "../../Components/Heading";
import { MVCForm, MVCFormServerProps } from "../MVCForm";
import { ModelStateValues } from "../Tools";
import { useDocumentTitle } from "Components/Hooks";
import { FitnessInstructorAddAdditionalInsuredModel } from "SharedConstants/Schema";

export function AddAdditionalInsured(
  props: FitnessInstructorAddAdditionalInsuredModel & {
    formProps: MVCFormServerProps;
  },
) {
  const getInitialValues = (values: ModelStateValues) => {
    return {
      ...values,
    };
  };

  const title = "Add Additional Insured";
  useDocumentTitle(`${title} - ${props.TitleProps.PageTitleSuffix}`);
  return (
    <>
      <Heading {...props} title={title} />
      <MVCForm
        {...props.formProps}
        initialValues={getInitialValues(props.formProps.initialValues)}
      >
        {({ isSubmitting }) => (
          <div className="narrowFieldBodies4">
            <AsteriskNotification />
            <Horizontal>
              <ErrorMessage>
                {props.formProps.initialErrors["GENERAL_ERROR"]}
              </ErrorMessage>
            </Horizontal>
            <AddStandardAIInput {...props.AddStandardAIInputProps} />
            <BulmaNavButtons
              backCaption="Cancel"
              backValue="Cancel"
              backIcon={<SmallIcon name="fa-times" />}
              continueCaption="Submit"
              continueValue="Submit this Additional Insured"
              isDisabled={isSubmitting}
            />
          </div>
        )}
      </MVCForm>
    </>
  );
}
